import { TabList as MuiTabList } from '@mui/lab';
import { styled, Tab, tabClasses, tabsClasses } from '@mui/material';

export const StyledTab = styled(Tab)(({ theme }) => ({
  padding: theme.spacing(0.2, 1),
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  background: theme.palette.custom.OV.sys.surfaceContainer,
  minHeight: `3rem`,
  borderBottom: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,

  [`&.${tabClasses.selected}`]: {
    background: 'transparent',
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
    border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
    borderBottom: 'none',
  },
}));

export const StyledTabList = styled(MuiTabList)({
  [`.${tabsClasses.indicator}`]: {
    display: 'none',
  },
});

